var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { env } from '../environment';
import style from '../css/social.css';
let SocialShare = class SocialShare extends LitElement {
    constructor() {
        super(...arguments);
        this.type = '';
        this.aim = 'gs1';
        this.version = '';
        this.title = '';
    }
    static get styles() {
        if (env.debug) {
            return css `
        `;
        }
        return [style];
    }
    getSocialLinks() {
        if (this.aim == "gs1") {
            return html `
      <a class="social-link social-icon x-twitter" target="_blank" href="https://twitter.com/GS1italy">
        <gs1-fa-icon family="fab" type="fa-x-twitter"></gs1-fa-icon>
      </a>
      <a class="social-link social-icon linkedin" target="_blank" href="https://linkedin.com/company/gs1-italy/">
        <gs1-fa-icon family="fab" type="fa-linkedin-in"></gs1-fa-icon>
      </a>
      <a class="social-link social-icon youtube" target="_blank" href="https://www.youtube.com/c/GS1ItalyTV">
        <gs1-fa-icon family="fab" type="fa-youtube"></gs1-fa-icon>
      </a>
      <a class="social-link social-icon facebook" target="_blank" href="https://facebook.com/GS1Italy">
        <gs1-fa-icon family="fab" type="fa-facebook-f"></gs1-fa-icon>
      </a>
      <a class="social-link social-icon instagram" target="_blank" href="https://www.instagram.com/gs1italy/">
        <gs1-fa-icon family="fab" type="fa-instagram"></gs1-fa-icon>
      </a>
      `;
        }
        else if (this.aim == "servizi") {
            return html `
      <a class="social-link social-icon linkedin" target="_blank" href="https://linkedin.com/company/gs1-it-servizi/">
        <gs1-fa-icon family="fab" type="fa-linkedin-in"></gs1-fa-icon>
      </a>
      <a class="social-link social-icon facebook" target="_blank" href="https://facebook.com/GS1Italy-Servizi-107857358775348">
        <gs1-fa-icon family="fab" type="fa-facebook-f"></gs1-fa-icon>
      </a>
      <a class="social-link social-icon instagram" target="_blank" href="https://www.instagram.com/gs1italyservizi/">
        <gs1-fa-icon family="fab" type="fa-instagram"></gs1-fa-icon>
      </a>
      <a class="social-link social-icon youtube" target="_blank" href="https://www.youtube.com/@gs1italyservizi">
        <gs1-fa-icon family="fab" type="fa-youtube"></gs1-fa-icon>
      </a>
      `;
        }
        else {
            return html ``;
        }
    }
    copyToClipboard() {
        var el = document.createElement("textarea");
        el.value = window.location.href;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }
    mailTo() {
        var mail_subject = document.querySelector('title')?.text || 'Condivisione pagina GS1';
        var mail_body = window.location.href;
        window.location.assign("mailto:?subject=" + mail_subject + "&body=" + mail_body);
    }
    facebookShare() {
        var url = "https://www.facebook.com/sharer/sharer.php?u=" + window.location.href;
        window.open(url, '_blank');
    }
    twitterShare() {
        var url = "https://twitter.com/intent/tweet?url=" + window.location.href + "&lang=it";
        window.open(url, '_blank');
    }
    linkedinShare() {
        var url = "https://linkedin.com/cws/share?url=" + window.location.href;
        window.open(url, '_blank');
    }
    render() {
        return html `
    ${env.debug ? html `<link rel="stylesheet" href="/css/social.css" />` : html ``}
    <div class="gs1-social ${this.type}">
      ${this.title != '' ? html `<p>${this.title}</p>` : html ``}
      ${this.version == 'share' ? html `
      <div class="social-icons">
        <a class="social-link social-icon link" @click="${this.copyToClipboard}">
          <gs1-fa-icon family="fas" type="fa-link"></gs1-fa-icon>
        </a>
        <a class="social-link social-icon facebook" @click="${this.facebookShare}">
          <gs1-fa-icon family="fab" type="fa-facebook-f"></gs1-fa-icon>
        </a>
        <a class="social-link social-icon x-twitter" @click="${this.twitterShare}">
          <gs1-fa-icon family="fab" type="fa-x-twitter"></gs1-fa-icon>
        </a>
        <a class="social-link social-icon linkedin" @click="${this.linkedinShare}">
          <gs1-fa-icon family="fab" type="fa-linkedin-in"></gs1-fa-icon>
        </a>
        <a class="social-link social-icon email" @click="${this.mailTo}">
          <gs1-fa-icon family="fas" type="fa-envelope"></gs1-fa-icon>
        </a>
      </div>
      ` : html `
      <div class="social-icons">
        ${this.getSocialLinks()}
      </div>
      `}
    </div>`;
    }
};
__decorate([
    property()
], SocialShare.prototype, "type", void 0);
__decorate([
    property()
], SocialShare.prototype, "aim", void 0);
__decorate([
    property()
], SocialShare.prototype, "version", void 0);
__decorate([
    property()
], SocialShare.prototype, "title", void 0);
SocialShare = __decorate([
    customElement('gs1-social')
], SocialShare);
export { SocialShare };
//# sourceMappingURL=social.js.map